<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.$axios
      .get("https://api.lotusdata.com/v1/buser/token", {
        params: {
          username: "uuapp.li@qq.com",
          password: "123123",
          refreshtoken: 0,
        },
      })
      .then(
        (res) => {
          if (res.data.code == 0) {
            var TOKEN = res.data.token;
            localStorage.setItem("TOKEN", "JWT " + TOKEN);
          }
        },
        function () {
          console.log("数据请求失败");
        }
      );
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* height: 100%; */
  height: auto;
  padding: 0;
  overflow-x: hidden;
}
html,
body {
  background: #fff;
  margin: 0;
}
p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue